export const faqs = [
  {
    question:
      "What are the aims and objectives of the National Minorities Development and Finance Corporation (NMDFC), and when was it established?",
    answer:
      "NMDFC was incorporated on 30th September 1994 with the objective of promoting economic and developmental activities for the benefit of the “backward sections” among the notified minorities. The focus is specifically on occupational groups and women.",
  },

  {
    question: "Who are the promoters of NMDFC?",
    answer:
      "NMDFC is promoted jointly by the Government of India and the respective State Governments/UT Administrations. Initially, the State Governments of Andhra Pradesh, Bihar, Karnataka, and Uttar Pradesh, along with the Central Government, played a key role in its promotion.",
  },

  {
    question:
      "Why are states required to contribute to NMDFC's equity, unlike other apex corporations?",
    answer:
      "NMDFC operates as a joint venture between the States and the Central Government, necessitating state contributions to its equity.",
  },

  {
    question: "Which State/UT has not yet nominated an SCA for NMDFC?",
    answer:
      "The State of Telangana has not yet nominated an SCA for NMDFC.",
  },

  {
    question: "Does NMDFC require any security for its loans?",
    answer:
      "Yes, NMDFC Loans to State Channelizing Agencies are secured against a guarantee from the State Government/UT Administration.",
  },
];
